import React, {useState, useEffect, Fragment} from 'react'
import useCalendar from '@/modern/hooks/useCalendar'
import useSellerInfo from '@/modern/actions/useSellerInfo'

import {Hour, SliderDays, ArrowLeft, ArrowRight, Carousel, Slide, CarouselContainer, HourInfo} from './style'


export default ({ setContinueIsActive, dayActive, hourActive, setHourActive }) => {
    const {getArrayOfDates, formatTime, isToday, add30Minutes, subtract30Minutes, isAvaiable, getRoundedNowDate} = useCalendar()
    const {sellerInfo} = useSellerInfo('weekSchedule')


    const [slideLength, setSlideLength] = useState(0)
    const [pressedLeft, setPressedLeft] = useState(false)
    const [datesSchedule, setDatesSchedule] = useState([])
    const [animate, setAnimate] = useState(false)
    const [animateBorder, setAnimateBorder] = useState(false)

    useEffect(() => {
            const arrayOfDates = getArrayOfDates(dayActive.dayOfWeekNumber, dayActive.isHoliday)
            setDatesSchedule(arrayOfDates)
            const index = arrayOfDates.findIndex(date => date.getTime() === hourActive.getTime())
            const now = new Date()
            const endHours = arrayOfDates[arrayOfDates.length - 1]
            const startHours = arrayOfDates[0]
            const isLate = now.getTime() > (endHours.getTime() - 1000 * 60 * 60 * 1.9833)
            const isNoon = (now.getTime() + 1000 * 60 * 60 * 1.9833) < (startHours.getTime())
            setAnimate(false)
            if(isLate && isToday(dayActive)) {
                setSlideLength(-21 * (arrayOfDates.length - 1) - 21)
                setHourActive(endHours)
                setContinueIsActive(false)
            } else if(isNoon && isToday(dayActive)) {
                setSlideLength(-21)
                setHourActive(startHours)
                setContinueIsActive(false)
            } else {
                if(isToday(dayActive) && index !== -1) {
                    setSlideLength(-21 * index - 21)
                    const nowRounded = getRoundedNowDate()
                    setHourActive(nowRounded)
                    setContinueIsActive(isAvaiable(nowRounded))
                } else if(isToday(dayActive) && index === -1) {
                    setSlideLength(-21 * (arrayOfDates.length - 1) - 21)
                    setHourActive(endHours)
                    setContinueIsActive(false)
                } else if (!isToday(dayActive))
                    setSlideLength(-21)
            }
    }, [dayActive.day, sellerInfo])

    const handleRight = () => {
        if(hourActive.getTime() !== datesSchedule[datesSchedule.length - 1].getTime()) {
            setAnimateBorder(true)
            setAnimate(true)
            setPressedLeft(false)

            const added30Minutes = add30Minutes(hourActive)

            setHourActive(added30Minutes)
            setSlideLength(slideLength - 21)

            if(isToday(dayActive))
                setContinueIsActive(isAvaiable(added30Minutes))
            else
                setContinueIsActive(true)
        }
    }

    const handleLeft = () => {
        setAnimateBorder(true)
        if(hourActive.getTime() !== datesSchedule[0].getTime()) {
            setAnimate(true)
            setPressedLeft(true)

            const subtracted30Minutes = subtract30Minutes(hourActive)

            setHourActive(subtracted30Minutes)
            setSlideLength(slideLength + 21)

            if(isToday(dayActive))
                setContinueIsActive(isAvaiable(subtracted30Minutes))
            else
                setContinueIsActive(true)
        }
    }

    const handleClick = date => {
        const index = datesSchedule.findIndex(d => d.getHours() === date.getHours() && d.getMinutes() === date.getMinutes())
        const index2 = datesSchedule.findIndex(d => d.getHours() === hourActive.getHours() && d.getMinutes() === hourActive.getMinutes())
        const difference = Math.abs(index - index2)
        const goingToRight = datesSchedule[index].getTime() > hourActive.getTime()

        if(difference === 2)
            setAnimateBorder(false)
         else
            setAnimateBorder(true)

        setAnimate(true)
        setPressedLeft(!goingToRight)
        setHourActive(date)
        setSlideLength(-21 * index - 21)

        if(isToday(dayActive))
            setContinueIsActive(isAvaiable(date))
        else
            setContinueIsActive(true)
    }

    const dataFormTest = 'form_hour_videochamada'
    const dataTestLabel = 'sliderhour_videochamada'

    function handleDataQA(date) {
      return isToday(dayActive) && !isAvaiable(date) ? 'disabled' : 'enabled'
    }

    return (
        <Hour data-test-component={dataFormTest}>
            <CarouselContainer>
                {datesSchedule.length > 2 &&
                <Fragment>
                    <ArrowLeft
                    data-qa="btn_calendar_hour_prev"
                    onClick={handleLeft}
                    disabled={hourActive.getTime() === datesSchedule[0].getTime()}> {'<'} </ArrowLeft>
                        <SliderDays data-test-component={dataTestLabel}  >
                            <Carousel  slideLeft={slideLength} slideRight={slideLength} pressedLeft={pressedLeft === true} animate={animate}>
                            <Slide data-test-component={dataTestLabel}>
                                    <HourInfo></HourInfo>
                            </Slide>
                            <Slide data-test-component={dataTestLabel}>
                                    <HourInfo></HourInfo>
                            </Slide>
                            <Slide data-test-component={dataTestLabel}>
                                    <HourInfo></HourInfo>
                            </Slide>
                                {datesSchedule.map(date => {
                                    const {formattedHour, formattedMinutes} = formatTime(date.getHours(), date.getMinutes())
                                    return (
                                        <Slide data-test-component={dataTestLabel}
                                        data-qa={`hour_${handleDataQA(date)}`}
                                        isGray={isToday(dayActive) && !isAvaiable(date)}
                                        isSelected={date.getHours() === hourActive.getHours() && date.getMinutes() === hourActive.getMinutes()}
                                        onClick={() => handleClick(date)}
                                        animateBorder={animateBorder}
                                        >
                                            <HourInfo>{formattedHour}:{formattedMinutes}</HourInfo>
                                        </Slide>
                                    )
                                })}
                            </Carousel>
                        </SliderDays>
                    <ArrowRight
                    data-qa="btn_calendar_hour_next"
                    onClick={handleRight}
                    disabled={hourActive.getTime() === datesSchedule[datesSchedule.length - 1].getTime()}> {'>'} </ArrowRight>
                </Fragment>
                }
            </CarouselContainer>
        </Hour>
    )
}
